const keys = [];
let printWarnings = true;
export const supressWarnings = ()=>{
    printWarnings = false;
};
/**
 *
 * @param {string} key - key
 * @param {any} args - args that will be passed to logger.warn
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default ((key, ...args)=>{
    if (process.env.NODE_ENV !== 'production') {
        if (keys.indexOf(key) === -1 && printWarnings) {
            keys.push(key);
            // eslint-disable-next-line no-console
            console.warn(...args);
        }
    }
});
